export default "__VITE_ASSET__BOu6rOHz__"